// extracted by mini-css-extract-plugin
export var cardLayout = "_8g-1";
export var paginationContainer = "_8g-0";